module.exports = new __parcel__URL__("logo_blue.61cbcc3f.svg").toString();